<template lang="pug">
    section.prices-step
        Price(
            v-if="mainPriceIndex >= 0"
            :form="form"
            :rules="rules"
            :price="form.prices[mainPriceIndex]"
            scope="stepper"
            :deletable="false"
        )
        transition(name="slide-decent-vertical")
            .special-prices(v-if="specialPrices.length")
                transition-group(name="slide-decent-vertical" tag="div")
                    Price(
                        v-for="(price, i) in form.prices" :key="price.id"
                        v-if="price.type !== 'main'"
                        :form="form"
                        :rules="rules"
                        :price="price"
                        scope="stepper"
                    )
        transition(name="slide-decent-vertical")
            .alert.danger(v-if="missingGroups.length && form.prices[mainPriceIndex] && form.prices[mainPriceIndex].value")
                p {{ $t('Be aware that only customers within customer groups with defined prices will be able to see this product!') }}<br>
                    | {{ $t('Consider generating the missing prices by clicking the button below.') }}
        el-button(
            v-if="missingGroups.length && form.prices[mainPriceIndex] && form.prices[mainPriceIndex].value"
            type="warning"
            @click="generateMissingGroupPrices"
        ) {{ $t('Generate missing customer group prices') }}
        el-button(type="primary" icon="el-icon-fa-plus fas" @click="addSalePrice") {{ $t('Add special price') }}
</template>

<i18n>
{
    "de": {
        "Be aware that only customers within customer groups with defined prices will be able to see this product!": "Dieses Produkt wird nur Kunden in Kundenguppen mit vorhandenen Preisen angezeigt!",
        "Consider generating the missing prices by clicking the button below.": "Die fehlenden Preise können per Klick auf die untere Schaltfläche generiert werden.",
        "Generate missing customer group prices": "Fehlende Kundengruppenpreise generieren",
        "Add special price": "Sonderpreis hinzufügen"
    }
}
</i18n>

<script>
import _ from 'lodash';
import uniqid from 'uniqid';

import pinia from '@/pinia';
import { useSetupStore, useShopProductStore } from '@/stores';

import Price from '@/extensions/shop/views/Product/Form/Partials/Price';

export default {
    name: 'PricesStep',
    props: {
        form: {
            type: Object,
            required: true
        },
        rules: {
            type: Object,
            required: true
        }
    },
    components: {
        Price
    },
    computed: {
        mainPriceIndex() {
            return _.findIndex(this.form.prices, el => el.type === 'main');
        },
        specialPrices() {
            return this.form.prices.filter(el => el.type !== 'main');
        },
        groupPrices() {
            return this.form.prices.filter(el => el.type === 'group' && el.customerGroup != null);
        },
        missingGroups() {
            // check if all customer groups have their own prices

            let missingGroups = [];

            const defaultCustomerGroup = _.get(this.activeShop, 'defaultCustomerGroup');
            const groups = this.options.customerGroup.items;

            if (defaultCustomerGroup && groups.length) {
                const existingGroupIDs = this.groupPrices.map(el => el.customerGroup.id);
                missingGroups = groups.filter(el => {
                    return el.id !== defaultCustomerGroup.id && !existingGroupIDs.includes(el.id);
                });
            }

            return missingGroups;
        },
        activeShop() {
            return this.activeCms.shop;
        },
        setupStore() {
            return useSetupStore();
        },
        shopProductStore() {
            return useShopProductStore(pinia);
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        options() {
            return this.shopProductStore.options;
        }
    },
    methods: {
        generateMissingGroupPrices() {
            if (this.missingGroups && this.missingGroups.length) {
                this.missingGroups.forEach(customerGroup => {
                    this.form.prices.push({
                        id: uniqid('new:'),
                        value: _.get(this.form.prices[this.mainPriceIndex], 'value'),
                        tax: _.get(this.form.prices[this.mainPriceIndex], 'tax'),
                        tax_rate: _.get(this.form.prices[this.mainPriceIndex], 'tax_rate'),
                        type: 'group',
                        customerGroup,
                        min_qty: null,
                        start_at: null,
                        end_at: null
                    });
                    this.rules.prices.push({
                        type: 'required',
                        value: 'required|min_value:0',
                        min_qty: 'required|integer|min_value:1',
                        start_at: 'required',
                        end_at: 'required',
                        customerGroup: { id: 'required' },
                        // tax: { value: 'required' }
                    });
                });
            }
        },
        addSalePrice() {
            const customerGroup = _.get(this.activeShop, 'defaultCustomerGroup');

            this.form.prices.push({
                id: uniqid('new:'),
                value: _.get(this.form.prices[this.mainPriceIndex], 'value'),
                tax: _.get(this.form.prices[this.mainPriceIndex], 'tax'),
                tax_rate: _.get(this.form.prices[this.mainPriceIndex], 'tax_rate'),
                type: 'sale',
                customerGroup,
                min_qty: null,
                start_at: null,
                end_at: null
            });
            this.rules.prices.push({
                type: 'required',
                value: 'required|min_value:0',
                min_qty: 'required|integer|min_value:1',
                start_at: 'required',
                end_at: 'required',
                customerGroup: { id: 'required' },
                // tax: { value: 'required' }
            });
        }
    }
};
</script>

<style lang="sass" scoped>
.special-prices
    border-top: 3px dotted $--shop-color-primary
    padding-top: 22px
</style>
